var map = {
	"./addnewvehicle/addnewvehicle.module": [
		"./src/app/addnewvehicle/addnewvehicle.module.ts",
		"addnewvehicle-addnewvehicle-module"
	],
	"./carddetail/carddetail.module": [
		"./src/app/carddetail/carddetail.module.ts",
		"carddetail-carddetail-module"
	],
	"./chat/chat.module": [
		"./src/app/chat/chat.module.ts",
		"chat-chat-module"
	],
	"./contact-us/contact-us.module": [
		"./src/app/contact-us/contact-us.module.ts",
		"contact-us-contact-us-module"
	],
	"./customer-detail/customer-detail.module": [
		"./src/app/customer-detail/customer-detail.module.ts",
		"customer-detail-customer-detail-module"
	],
	"./customer-request/customer-request.module": [
		"./src/app/customer-request/customer-request.module.ts",
		"customer-request-customer-request-module"
	],
	"./documentmanagement/documentmanagement.module": [
		"./src/app/documentmanagement/documentmanagement.module.ts",
		"documentmanagement-documentmanagement-module"
	],
	"./drivinglicense/drivinglicense.module": [
		"./src/app/drivinglicense/drivinglicense.module.ts",
		"drivinglicense-drivinglicense-module"
	],
	"./edit-profile/edit-profile.module": [
		"./src/app/edit-profile/edit-profile.module.ts",
		"edit-profile-edit-profile-module"
	],
	"./history/history.module": [
		"./src/app/history/history.module.ts",
		"history-history-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./invite/invite.module": [
		"./src/app/invite/invite.module.ts",
		"invite-invite-module"
	],
	"./invitefriends/invitefriends.module": [
		"./src/app/invitefriends/invitefriends.module.ts",
		"invitefriends-invitefriends-module"
	],
	"./location/location.module": [
		"./src/app/location/location.module.ts",
		"location-location-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./notifications/notifications.module": [
		"./src/app/notifications/notifications.module.ts",
		"notifications-notifications-module"
	],
	"./paymentmethod/paymentmethod.module": [
		"./src/app/paymentmethod/paymentmethod.module.ts",
		"paymentmethod-paymentmethod-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./register/register.module": [
		"./src/app/register/register.module.ts",
		"register-register-module"
	],
	"./setting/setting.module": [
		"./src/app/setting/setting.module.ts",
		"setting-setting-module"
	],
	"./slides/slides.module": [
		"./src/app/slides/slides.module.ts",
		"slides-slides-module"
	],
	"./terms-condictions/terms-condictions.module": [
		"./src/app/terms-condictions/terms-condictions.module.ts",
		"terms-condictions-terms-condictions-module"
	],
	"./vehiclemanagement/vehiclemanagement.module": [
		"./src/app/vehiclemanagement/vehiclemanagement.module.ts",
		"vehiclemanagement-vehiclemanagement-module"
	],
	"./verify-otp/verify-otp.module": [
		"./src/app/verify-otp/verify-otp.module.ts",
		"verify-otp-verify-otp-module"
	],
	"./wallet/wallet.module": [
		"./src/app/wallet/wallet.module.ts",
		"wallet-wallet-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;